var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 9.2726C4.75821 9.17592 4.5625 8.91518 4.5625 8.60932C4.5625 8.22143 4.87774 7.90619 5.26563 7.90619C5.65351 7.90619 5.96875 8.22143 5.96875 8.60932C5.96875 8.91518 5.77305 9.17591 5.5 9.2726V10.4884C5.5 10.6115 5.39512 10.7187 5.26563 10.7187C5.14023 10.7187 5.03125 10.6156 5.03125 10.4884V9.2726ZM1.75 5.5625C0.973045 5.56484 0.34375 6.19063 0.34375 6.97285V11.6515C0.34375 12.4308 0.9748 13.0618 1.7541 13.0618H8.7771C9.55639 13.0618 10.1874 12.4349 10.1874 11.6515V6.97285C10.1874 6.19531 9.55873 5.56426 8.78119 5.5625V3.92135C8.78119 1.9796 7.20319 0.40625 5.26549 0.40625C3.32374 0.40625 1.74979 1.98005 1.74979 3.92135L1.75 5.5625ZM3.15625 5.5625V3.9224C3.15625 2.75404 4.10079 1.8125 5.26555 1.8125C6.42805 1.8125 7.37485 2.75704 7.37485 3.9224V5.5625H3.15625Z",
    fill: "#777D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockNew);
export default __webpack_public_path__ + "static/media/lock_new.cf300cd16c475e8de41e6901ce72e239.svg";
export { ForwardRef as ReactComponent };